import Parser from '@postlight/parser';

import { rssDiag, rssDiagContext, serializeAxiosError } from '../rssDiag';

const getRemoteProxyPrefix = () => {
  try {
    const p = typeof process !== 'undefined' && process.env && process.env.REACT_APP_RSS_CORS_PROXY;
    if (p && typeof p === 'string' && p.length) return p;
  } catch (_) {}
  return null;
};

const useDevServerProxy = () => {
  try {
    return typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development';
  } catch (_) {
    return false;
  }
};

/** Same-origin / env proxy as RSS fetch — cors-anywhere.herokuapp.com no longer works (403). */
const getProxiedArticleUrl = (targetUrl) => {
  if (useDevServerProxy() && typeof window !== 'undefined' && window.location && window.location.origin) {
    return `${window.location.origin}/rss-proxy?url=${encodeURIComponent(targetUrl)}`;
  }
  const remote = getRemoteProxyPrefix();
  if (remote) {
    return remote + encodeURIComponent(targetUrl);
  }
  return targetUrl;
};

const imageFromEncodedContent = (item) => {
  if (!item.content) return undefined;
  try {
    const doc = new DOMParser().parseFromString(item.content, 'text/html');
    const img = doc.querySelector('img[src]');
    if (!img) return undefined;
    const src = img.getAttribute('src');
    if (!src) return undefined;
    return new URL(src, item.link).href;
  } catch (_) {
    return undefined;
  }
};

const parse = (item) => {
  const fetchUrl = getProxiedArticleUrl(item.link);
  const proxied = fetchUrl !== item.link;
  return Parser.parse(fetchUrl)
    .then((data) => ({ ...item, mercury: data }))
    .catch((err) => {
      rssDiag('warn', 'mercury_parse_failed_using_feed_fallback', {
        ...rssDiagContext(),
        articleLink: item.link,
        fetchUrl,
        proxied,
        ...serializeAxiosError(err),
      });
      return {
        ...item,
        mercury: {
          title: item.title,
          content: item.content || '',
          lead_image_url: item.image || null,
          excerpt: '',
        },
      };
    });
};

const useImage = (item) => {
  const m = item.mercury;
  let image = (m && m.lead_image_url) || item.image;
  if (!image) {
    image = imageFromEncodedContent(item);
  }
  return { ...item, image };
};

const useContent = (item) => {
  const m = item.mercury;
  const content = (m && m.content) || item.content;
  return { ...item, content };
};

export default { parse, useImage, useContent };
